



























































import Vue from "vue";
import Component from "vue-class-component";

import StaticList from "./StaticList.vue";
import { QuotientFamilial } from "../logic/enums";
import {
  PrixParStatut,
  OptionPrixCamp,
  OptionPrixParticipant,
  Semaine,
  Date_,
  Jours,
  OptionQuotientFamilial
} from "@/shared/logic/types";
import { formatDateObject, isQuotientFamilialActif } from "../logic/utils";

const OptionPrixParticipantFieldProps = Vue.extend({
  props: {
    option: Object as () => OptionPrixCamp,
    quotientFamilialCamp: Array as () => OptionQuotientFamilial,
    optionPrixParticipant: Object as () => OptionPrixParticipant,
    quotientFamilialParticipant: Number,
    dateDebutCamp: (String as unknown) as () => Date_
  }
});

type optionKind = "statut" | "semaine" | "quotient_familial" | "jour";
type kindCrible = { [P in optionKind]: boolean };
@Component({
  components: { StaticList }
})
export default class OptionPrixParticipantField extends OptionPrixParticipantFieldProps {
  innerQuotientFamilialParticipant = 0;

  get kind(): kindCrible {
    const a = this.option.active as optionKind;
    return {
      statut: a == "statut",
      semaine: a == "semaine",
      quotient_familial: a == "quotient_familial",
      jour: a == "jour"
    };
  }

  get hasQuotientFamilial() {
    return isQuotientFamilialActif(this.quotientFamilialCamp);
  }

  get optionsStatut() {
    return [{ value: 0, text: "Pas d'option" }].concat(
      (this.option.statut || []).map((item: PrixParStatut) => {
        return { value: item.id, text: item.statut };
      })
    );
  }

  get optionsSemaine() {
    return [
      { value: Semaine.SComplet, text: "Tout le séjour" },
      { value: Semaine.SSe1, text: "Semaine 1" },
      { value: Semaine.SSe2, text: "Semaine 2" }
    ];
  }

  maxQuotientFamilial = QuotientFamilial[QuotientFamilial.length - 1];

  get optionsJour() {
    const dateDebut = new Date(this.dateDebutCamp);
    return (this.option.jour || []).map((_, i) => {
      const dateJour = new Date(dateDebut.valueOf());
      dateJour.setDate(dateDebut.getDate() + i);
      return { value: i, text: formatDateObject(dateJour) };
    });
  }

  onChangeQF(qf: string) {
    this.innerQuotientFamilialParticipant = Number(qf);
    this.onChange();
  }

  onChange() {
    this.$emit(
      "change",
      this.optionPrixParticipant,
      this.innerQuotientFamilialParticipant
    );
  }

  // on transforme le champ jour pour être plus intuitif en case de présence complète
  get valueJour() {
    if ((this.optionPrixParticipant.jour || []).length == 0) {
      // rien coché -> affiche tout coché
      return this.optionsJour.map(o => o.value);
    }
    return this.optionPrixParticipant.jour;
  }

  // on transforme le champ jour pour être plus intuitif en case de présence complète
  onChangeJour(jour: Jours) {
    if ((jour || []).length == this.optionsJour.length) {
      // tout coché -> équivalent à rien coché
      jour = [];
    }
    Vue.nextTick(() => {
      // bug due to checkbox synchronisation
      this.optionPrixParticipant.jour = jour;
      this.onChange();
    });
  }
}
